<template>
  <v-layout align-start>
    <v-flex xs12>
      <v-toolbar text color="white">
        <v-toolbar-title>Picking y Packing</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="brown lighten-1 mx-1" fab small dark @click.native="listar">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn class="deep-orange darken-3 mx-1" fab small dark @click.native="abrirNuevaSolicitud">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn class="red mx-1" fab small dark @click.native="$refs.file_input_pickings.click()">
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
        <input type="file" style="display: none" ref="file_input_pickings" accept=".xlsx, .odt"
          @change="importarExcel2Picking($event)" />
      </v-toolbar>

      <v-data-table dense :headers="headers" :items="solicitudes" :items-per-page="50" :sort-by="['creacion']"
        :sort-desc="[true, false]" :search="filtros.ref_cliente" single-expand :expanded="expanded" item-key="_id"
        show-expand class="elevation-1" :footer-props="{
          itemsPerPageOptions: [15, 50, 100, -1],
        }">
        <template v-slot:top>
          <v-container grid-list-md>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-layout wrap>
              <v-flex xs6 sm6 md2>
                <v-dialog ref="dialog_filtro_fecha_inicio" v-model="dialog_filtro_fecha_inicio"
                  :return-value.sync="filtro_remoto_fecha_inicio" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="filtro_remoto_fecha_inicio_formateada" label="Fecha inicio"
                      prepend-icon="event" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="filtro_remoto_fecha_inicio" :max="fecha_inicio_maxima" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialog_filtro_fecha_inicio = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="
                      $refs.dialog_filtro_fecha_inicio.save(
                        filtro_remoto_fecha_inicio
                      )
                      ">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6 sm6 md2>
                <v-dialog ref="dialog_filtro_fecha_fin" v-model="dialog_filtro_fecha_fin"
                  :return-value.sync="filtro_remoto_fecha_fin" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="filtro_remoto_fecha_fin_formateada" label="Fecha fin" prepend-icon="event"
                      readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="filtro_remoto_fecha_fin" :min="fecha_fin_minima" :max="fecha_fin_maxima"
                    scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialog_filtro_fecha_fin = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="
                      $refs.dialog_filtro_fecha_fin.save(
                        filtro_remoto_fecha_fin
                      )
                      ">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6 sm4 md2>
                <v-select v-model="filtro_remoto_estado" :items="vselect_estados" item-text="nombre" item-value="valor"
                  label="Estado"></v-select>
              </v-flex>
              <v-flex xs11 sm6 md3>
                <v-text-field v-model="filtros.ref_cliente" append-icon="search" label="Ref. Cliente" single-line
                  hide-details></v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-icon class="mt-2" @click="limpiarFiltrosLocales()" color="red">clear</v-icon>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn class="green mx-1" fab small dark @click.native="exportarPicking2Excel">
                  <v-icon>mdi-file-excel-outline</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
        <template v-slot:item.creacion="{ item }">{{
          formatearFechayHora(item.creacion)
        }}</template>
        <template v-slot:item.estado="{ item }">
          <v-icon :color="getColorEstado(item.estado)" dark>{{
            getIconEstado(item.estado)
          }}</v-icon>
        </template>
        <template v-slot:item.total_articulos="{ item }">
          {{ item.total_articulos }}
          <v-icon v-if="esEditable(item)" class="ml-2" @click="abrirArticulos(item)" color="black">edit</v-icon>
          <v-icon v-else class="ml-2" @click="abrirArticulos(item)" color="black">mdi-eye</v-icon>
        </template>
        <template v-slot:item.total_adjuntos="{ item }">
          {{ item.adjuntos ? item.adjuntos.length : 0 }}
          <v-icon v-if="
            item.estado == estados.SOLICITADO ||
            item.estado == estados.SOLICITADO_SIN_STOCK
          " class="ml-2" @click="abrirAdjuntos(item)" color="black">edit</v-icon>
          <v-icon v-else class="ml-2" @click="abrirAdjuntos(item)" color="black">mdi-eye</v-icon>
        </template>
        <template v-slot:item.envio.grabado="{ item }">
          <v-icon v-if="item.envio.grabado" @click="verEtiqueta(item)" color="black">mdi-barcode</v-icon>
          <v-icon v-else-if="item.estado == 'Grabando'" color="blue">mdi-timer-sand</v-icon>
        </template>
        <template v-slot:item.accion="{ item }">
          <v-icon @click="cambiarEstado2Cancelado(item)" :color="getColorEstado(estados.CANCELADO)">{{
            getIconEstado(estados.CANCELADO) }}</v-icon>
          <v-icon v-if="esEditable(item)" @click="abrirSolicitud(item)" color="black">edit</v-icon>
          <v-icon v-else @click="abrirSolicitud(item)" color="black">mdi-eye</v-icon>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">{{ getDatosAdicionales(item) }}</td>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogo_picking" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm3 md3>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.ref_cliente" label="*Referencia"
                    :readonly="!esEditable()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.servicio" label="*Servicio" type="Number"
                    min="1" step="1" :readonly="!esEditable()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.horario" label="*Horario" type="Number"
                    min="1" step="1" :readonly="!esEditable()"></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.transportista" label="*Transportista"
                    type="Text" onkeyup="this.value = this.value.toLowerCase();"
                    :readonly="!esEditable()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.bultos" label="*Bultos" type="Number" min="1"
                    step="1" :readonly="!esEditable()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.peso" label="*Peso" type="Number" min="0.01"
                    :readonly="!esEditable()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.reembolso" label="*Reembolso" type="Number"
                    min="0" :readonly="!esEditable()"></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.destinatario.nombre" label="*Destinatario"
                    :readonly="!esEditable()"></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.destinatario.pais" label="*Cód. País"
                    type="Number" :readonly="!esEditable()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.destinatario.cp" label="*C.P."
                    :readonly="!esEditable()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.destinatario.poblacion" label="*Población"
                    :readonly="!esEditable()"></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.destinatario.direccion" label="*Dirección"
                    :readonly="!esEditable()"></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.destinatario.telefono" label="Teléfono"
                    :readonly="!esEditable()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.destinatario.movil" label="Móvil"
                    :readonly="!esEditable()"></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.destinatario.att" label="A la atención de"
                    :readonly="!esEditable()"></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.destinatario.email" label="Email"
                    type="email" :readonly="!esEditable()"></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.envio.destinatario.observaciones"
                    label="Observaciones de entrega" :readonly="!esEditable()"></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-text-field class="ma-0 pa-0" v-model="solicitud.observaciones_preparacion"
                    label="Observaciones de preparación" :readonly="!esEditable()"></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-label>*Campos obligatorios</v-label>
                </v-flex>

                <v-flex xs12 sm12 md12 v-show="!!validaMensaje">
                  <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!this.solicitud._id || this.esEditable()" color="primary darken-1"
              @click="cerrar">Cancelar</v-btn>
            <v-btn v-else color="primary darken-1" @click="cerrar">Cerrar</v-btn>
            <v-btn v-if="!this.solicitud._id" color="primary darken-1" @click="insertarSolicitud">Insertar</v-btn>
            <v-btn v-else-if="this.esEditable()" color="primary darken-1"
              @click="actualizarSolicitud">Actualizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogo_articulos" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Gestionar Artículos</span>
            <v-spacer></v-spacer>
            <v-btn class="green" fab small dark @click.native="exportarArticulosExcel()">
              <v-icon>mdi-file-excel-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider class="mx-2" inset horizonatal></v-divider>
          <v-card-text>
            <v-container v-if="
              solicitud.estado == estados.SOLICITADO ||
              solicitud.estado == estados.SOLICITADO_SIN_STOCK
            " grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm3 md3>
                  <v-text-field v-model="articulo.sku_cliente" label="*Sku Cliente"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field v-model="articulo.cantidad" label="*Cantidad" type="Number" min="1"></v-text-field>
                </v-flex>
                <v-flex xs6 sm2 md2>
                  <v-btn color="primary" dark class="mb-2" @click="insertarArticulo">Insertar</v-btn>
                </v-flex>
              </v-layout>
            </v-container>

            <v-data-table :headers="headers_articulos" :items="articulos" sort-by="sku_cliente" item-key="_id"
              :items-per-page="2000" hide-default-footer class="elevation-1">
              <template v-slot:item.empaquetados="{ item }">{{
                item.empaquetados
              }}</template>
              <template v-slot:item.accion="{ item }">
                <v-icon v-if="
                  solicitud.estado == estados.SOLICITADO ||
                  solicitud.estado == estados.SOLICITADO_SIN_STOCK
                " @click="eliminarArticulo(item)">delete</v-icon>
              </template>
            </v-data-table>

            <v-layout wrap>
              <v-flex xs12 sm12 md12 v-show="!!validaMensaje">
                <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-flex xs6 sm4 md3>
              Bultos:
              <v-icon v-if="this.esEditable() && solicitud.bultos > 1"
                @click="decrementarBultos()">remove_circle_outline</v-icon>
              {{ solicitud.bultos }}
              <v-icon v-if="this.esEditable()" @click="aumentarBultos()">add_circle_outline</v-icon>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrarDialogArticulos">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogo_adjuntos" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Gestionar Adjuntos</span>
          </v-card-title>
          <v-divider class="mx-2" inset horizonatal></v-divider>
          <v-card-text>
            <v-container v-if="
              solicitud.estado == estados.SOLICITADO ||
              solicitud.estado == estados.SOLICITADO_SIN_STOCK
            " grid-list-md>
              <v-layout wrap>
                <v-flex xs7 sm8 md10>
                  <v-file-input accept=".pdf" label="Seleccione el pdf" v-model="fichero_seleccionado"></v-file-input>
                </v-flex>
                <v-flex xs5 sm4 md2>
                  <v-btn v-if="fichero_seleccionado" right @click="insertarAdjunto">Adjuntar</v-btn>
                </v-flex>
              </v-layout>
            </v-container>

            <v-data-table :headers="headers_adjuntos" :items="adjuntos" sort-by="nombre" item-key="_id"
              :items-per-page="2000" hide-default-footer class="elevation-1">
              <template v-slot:item.accion="{ item }">
                <v-icon @click="descargarAdjunto(item)">mdi-file-download</v-icon>
                <v-icon v-if="
                  solicitud.estado == estados.SOLICITADO ||
                  solicitud.estado == estados.SOLICITADO_SIN_STOCK
                " @click="eliminarAdjunto(item)">delete</v-icon>
              </template>
            </v-data-table>

            <v-layout wrap>
              <v-flex xs12 sm12 md12 v-show="!!validaMensaje">
                <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrarDialogAdjuntos">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import XLSX from "xlsx";
import moment from "moment";

export default {
  data() {
    return {
      dialogo_picking: false,
      dialogo_articulos: false,
      dialogo_adjuntos: false,
      dialog_filtro_fecha_inicio: false,
      dialog_filtro_fecha_fin: false,
      filtro_remoto_fecha_inicio: null,
      filtro_remoto_fecha_inicio_formateada: null,
      filtro_remoto_fecha_fin: null,
      filtro_remoto_fecha_fin_formateada: null,
      filtro_remoto_estado: 1,
      filtros: {
        ref_cliente: "",
      },
      expanded: [],
      estados: {
        SOLICITADO: 1,
        SOLICITADO_SIN_STOCK: 2,
        PREPARANDO: 3,
        EMPAQUETADO: 4,
        EMBARCADO: 5,
        CANCELADO: 6,
        INCIDENCIA: 7,
      },
      vselect_estados_valores: {
        TODOS: 0,
        PENDIENTE: 1,
        EMBARCADO: 2,
        SIN_EXISTENCIAS: 3,
        CANCELADO: 4,
        INCIDENCIA: 5,
      },
      headers: [
        {
          text: "Fecha",
          value: "creacion",
          align: "center",
          sortable: true,
          filterable: false,
        },
        {
          text: "Ref. Cliente",
          value: "ref_cliente",
          align: "center",
          sortable: true,
        },
        {
          text: "Estado",
          value: "estado",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "Obs. de preparación",
          value: "observaciones_preparacion",
          sortable: false,
        },
        {
          text: "Bultos",
          value: "bultos",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "Artículos",
          value: "total_articulos",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "Adjuntos",
          value: "total_adjuntos",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "Grabar Envío",
          value: "envio.grabado",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "Acciones",
          value: "accion",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "",
          value: "data-table-expand",
          sortable: false,
          filterable: false,
        },
      ],
      headers_articulos: [
        {
          text: "Sku cliente",
          value: "sku_cliente",
          sortable: true,
        },
        {
          text: "Nombre",
          value: "nombre",
          sortable: true,
        },
        { text: "U.", value: "cantidad", align: "center", sortable: false },
        {
          text: "Empaquetados",
          value: "empaquetados",
          align: "center",
          sortable: false,
        },
        { text: "Acciones", value: "accion", align: "center", sortable: false },
      ],
      headers_adjuntos: [
        {
          text: "Nombre",
          value: "nombre",
          sortable: true,
        },
        { text: "Acciones", value: "accion", align: "center", sortable: false },
      ],
      solicitudes: [],
      solicitud: {
        _id: "",
        ref_cliente: "0",
        bultos: "1",
        envio: {
          transportista: "gls",
          servicio: "",
          horario: "",
          peso: "1",
          destinatario: {
            nombre: "",
            direccion: "",
            poblacion: "",
            pais: "34",
            cp: "",
            telefono: "",
            movil: "",
            email: "",
            observaciones: "",
            att: "",
          },
          reembolso: "0",
        },
        observaciones_preparacion: "",
        anotaciones: "",
        articulos: [],
        adjuntos: [],
      },
      articulo: {
        sku_cliente: "",
        cantidad: 1,
        empaquetados: 0,
      },
      fichero_seleccionado: null,
      adjunto: {
        nombre: "",
        fichero: null,
      },
      validaMensaje: [],
    };
  },
  computed: {
    formTitle() {
      return !this.solicitud._id
        ? "Nuevo"
        : this.esEditable()
          ? "Editar"
          : "Ver";
    },
    articulos() {
      return this.solicitud.articulos;
    },
    adjuntos() {
      return this.solicitud.adjuntos;
    },
    vselect_estados() {
      return [
        { nombre: "Pendiente", valor: this.vselect_estados_valores.PENDIENTE },
        { nombre: "Embarcado", valor: this.vselect_estados_valores.EMBARCADO },
        {
          nombre: "Sin existencias",
          valor: this.vselect_estados_valores.SIN_EXISTENCIAS,
        },
        { nombre: "Cancelado", valor: this.vselect_estados_valores.CANCELADO },
        {
          nombre: "Incidencia",
          valor: this.vselect_estados_valores.INCIDENCIA,
        },
        { nombre: "Todos", valor: this.vselect_estados_valores.TODOS },
      ];
    },
    fecha_inicio_inicial() {
      let fecha = new Date();
      fecha.setDate(new Date().getDate() - 14);
      return fecha.toISOString().substring(0, 10);
    },
    fecha_inicio_maxima() {
      let hoy = new Date();
      hoy.setDate(new Date().getDate());
      console.log("hoy", hoy.toISOString().substring(0, 10));
      console.log("this.filtro_remoto_fecha_fin", this.filtro_remoto_fecha_fin);
      let fecha =
        hoy.toISOString().substring(0, 10) < this.filtro_remoto_fecha_fin
          ? hoy.toISOString().substring(0, 10)
          : this.filtro_remoto_fecha_fin;
      console.log("fecha_inicio_inicial", fecha);
      return fecha;
    },
    fecha_fin_minima() {
      return this.filtro_remoto_fecha_inicio;
    },
    fecha_fin_maxima() {
      let fecha = new Date();
      fecha.setDate(new Date().getDate());
      return fecha.toISOString().substring(0, 10);
    },
  },
  watch: {
    dialogo_picking(val) {
      val || this.cerrar();
    },
    dialogo_articulos(val) {
      val || this.cerrarDialogArticulos();
    },
    dialogo_adjuntos(val) {
      val || this.cerrarDialogAdjuntos();
    },
    validaMensaje(val) {
      console.log("watch validaMensaje", val);
      if (
        val.length > 0 &&
        !this.dialogo_picking &&
        !this.dialogo_articulos &&
        !this.dialogo_adjuntos
      ) {
        this.$alert(val.join(". "));
      }
    },
    filtro_remoto_fecha_inicio(val) {
      console.log("filtro_remoto_fecha_inicio", val);
      let fecha = this.filtro_remoto_fecha_inicio;
      this.filtro_remoto_fecha_inicio_formateada = this.formatearFecha(fecha);
      console.log(
        "filtro_remoto_fecha_inicio_formateada",
        this.filtro_remoto_fecha_inicio_formateada
      );
      this.listar();
    },
    filtro_remoto_fecha_fin(val) {
      console.log("filtro_remoto_fecha_fin", val);
      let fecha = this.filtro_remoto_fecha_fin;
      this.filtro_remoto_fecha_fin_formateada = this.formatearFecha(fecha);
      console.log(
        "filtro_remoto_fecha_fin_formateada",
        this.filtro_remoto_fecha_fin_formateada
      );
      this.listar();
    },
    filtro_remoto_estado(val) {
      console.log("filtro_remoto_estado", val);
      this.listar();
    },
  },
  created() {
    this.listar();
    this.filtro_remoto_fecha_inicio = this.fecha_inicio_inicial;
    this.filtro_remoto_fecha_fin = this.fecha_fin_maxima;
  },
  methods: {
    print() {
      window.print();
    },
    formatearFecha(date) {
      if (!date) {
        return null;
      }

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatearFechayHora(time) {
      let m = moment(time);
      let fecha = m.format("YYYY-MM-DD");
      let hora = m.format("HH:mm:ss").substring(0, 5);
      return fecha + " " + hora;
    },
    getDatosAdicionales(item) {
      return `Ref. Cliente: ${item.ref_cliente}. Transportista: ${item.envio.transportista}. Destinatario: ${item.envio.destinatario.nombre}.
                Dirección: ${item.envio.destinatario.direccion}. ${item.envio.destinatario.cp} - ${item.envio.destinatario.poblacion} (País ${item.envio.destinatario.pais}).
                Destinatario: ${item.envio.destinatario.nombre}. Tfno: ${item.envio.destinatario.telefono}.
                Reembolso: ${item.envio.reembolso}. Kilos: ${item.envio.peso}`;
    },
    getIconEstado(estado) {
      switch (estado) {
        case this.estados.SOLICITADO:
          return "mdi-clipboard-list-outline";
        case this.estados.SOLICITADO_SIN_STOCK:
          return "mdi-clipboard-alert-outline";
        case this.estados.PREPARANDO:
          return "mdi-dropbox";
        case this.estados.EMPAQUETADO:
          return "mdi-package-variant-closed";
        case this.estados.EMBARCADO:
          return "mdi-truck";
        case this.estados.CANCELADO:
          return "mdi-file-cancel-outline";
        case this.estados.INCIDENCIA:
          return "mdi-alert";
      }
    },
    getColorEstado(estado) {
      switch (estado) {
        case this.estados.SOLICITADO:
          return "blue";
        case this.estados.SOLICITADO_SIN_STOCK:
          return "blue";
        case this.estados.PREPARANDO:
          return "purple";
        case this.estados.EMPAQUETADO:
          return "orange";
        case this.estados.EMBARCADO:
          return "green";
        case this.estados.CANCELADO:
          return "red";
        case this.estados.INCIDENCIA:
          return "#dcca28";
      }
      return "white";
    },
    getNombreEstado(estado) {
      switch (estado) {
        case this.estados.SOLICITADO:
          return "Solicitado";
        case this.estados.SOLICITADO_SIN_STOCK:
          return "Sin existencias";
        case this.estados.PREPARANDO:
          return "Preparando";
        case this.estados.EMPAQUETADO:
          return "Empaquetado";
        case this.estados.EMBARCADO:
          return "Embarcado";
        case this.estados.CANCELADO:
          return "Cancelado";
        case this.estados.INCIDENCIA:
          return "Incidencia";
      }
    },
    getEstadoFiltro2Estado(estado) {
      console.log("getEstadoFiltro2Estado estado", estado);
      switch (estado) {
        case this.vselect_estados_valores.TODOS:
          console.log(
            "TODOS this.vselect_estados_valores.TODOS",
            this.vselect_estados_valores.TODOS
          );
          return null;
        case this.vselect_estados_valores.PENDIENTE:
          return [
            this.estados.SOLICITADO,
            this.estados.PREPARANDO,
            this.estados.EMPAQUETADO,
          ];
        case this.vselect_estados_valores.SIN_EXISTENCIAS:
          return [this.estados.SOLICITADO_SIN_STOCK];
        case this.vselect_estados_valores.EMBARCADO:
          return [this.estados.EMBARCADO];
        case this.vselect_estados_valores.CANCELADO:
          return [this.estados.CANCELADO];
        case this.vselect_estados_valores.INCIDENCIA:
          return [this.estados.INCIDENCIA];
      }
    },
    limpiarFiltrosLocales() {
      this.filtros.ref_cliente = "";
    },
    limpiarSolicitud() {
      this.solicitud = {
        _id: "",
        ref_cliente: "0",
        bultos: "1",
        envio: {
          transportista: "gls",
          servicio: "",
          horario: "",
          peso: "1",
          destinatario: {
            nombre: "",
            direccion: "",
            poblacion: "",
            pais: "34",
            cp: "",
            telefono: "",
            movil: "",
            email: "",
            observaciones: "",
            att: "",
          },
          reembolso: "0",
        },
        observaciones_preparacion: "",
        anotaciones: "",
        total_articulos: "",
        total_adjuntos: "",
        articulos: [],
        adjuntos: [],
      };
      this.cod_barras = "";
      this.articulo = {
        cod_barras: "",
        sku_cliente: "",
        cantidad: 1,
        empaquetados: 0,
      };
      this.fichero_seleccionado = null;
      this.adjunto = {
        nombre: "",
        fichero: null,
      };
      this.validaMensaje = [];
    },
    limpiar() {
      this.limpiarSolicitud();
      this.solicitud.articulos = [];
      this.solicitud.adjuntos = [];
      this.validaMensaje = [];
    },
    esValido() {
      console.log("in esValido");
      this.validaMensaje = [];
      console.log("esValido this.solicitud", this.solicitud);
      if (!!this.solicitud.ref_cliente && this.solicitud.ref_cliente.length > 15) {
        this.validaMensaje.push("Referencia (texto máx 15 caracteres)");
      }
      if (this.solicitud.bultos === "" || isNaN(this.solicitud.bultos)) {
        this.validaMensaje.push("Bultos (número entero > 0)");
      }
      if (
        this.solicitud.envio.servicio === "" ||
        isNaN(this.solicitud.envio.servicio)
      ) {
        this.validaMensaje.push("Servicio (Número entero > 0)");
      }
      if (
        this.solicitud.envio.horario === "" ||
        isNaN(this.solicitud.envio.horario)
      ) {
        this.validaMensaje.push("Horario (número entero > 0)");
      }
      if (
        this.solicitud.envio.peso === "" ||
        isNaN(this.solicitud.envio.peso)
      ) {
        this.validaMensaje.push("Peso (Número no negativo)");
      }
      if (
        this.solicitud.envio.reembolso === "" ||
        isNaN(this.solicitud.envio.reembolso)
      ) {
        this.validaMensaje.push("Reembolso (Número decimal no negativo)");
      }
      if (!this.solicitud.envio.destinatario.nombre) {
        this.validaMensaje.push(
          "Nombre destinatario (texto de 2 a 80 caracteres)"
        );
      }
      if (this.solicitud.envio.destinatario.cp === "") {
        this.validaMensaje.push("Código Postal");
      }
      if (!this.solicitud.envio.destinatario.poblacion) {
        this.validaMensaje.push("Población (texto de 3 a 80 caracteres)");
      }
      if (!this.solicitud.envio.destinatario.direccion) {
        this.validaMensaje.push("Dirección (texto de 5 a 80 caracteres)");
      }
      if (
        this.solicitud.envio.destinatario.pais === "" ||
        isNaN(this.solicitud.envio.destinatario.pais)
      ) {
        this.validaMensaje.push("País (nº prefijo telefónico)");
      }
      console.log("this.validaMensaje", this.validaMensaje);
      return this.validaMensaje.length == 0;
    },
    esEditable(item) {
      if (!item) {
        item = this.solicitud;
      }
      return (
        !item._id ||
        item.estado == this.estados.SOLICITADO ||
        item.estado == this.estados.SOLICITADO_SIN_STOCK
      );
    },
    abrirNuevaSolicitud() {
      console.log("abrirNuevaSolicitud");
      this.validaMensaje = [];
      this.dialogo_picking = true;
    },
    abrirSolicitud(item) {
      console.log("abrirSolicitud", item);
      this.solicitud = Object.assign({}, item);
      console.log("Antes de abrir dialogo_picking");
      console.log("this.solicitud", this.solicitud);
      this.validaMensaje = [];
      this.dialogo_picking = true;
    },
    listar() {
      console.log("listar");
      if (!this.filtro_remoto_fecha_inicio || !this.filtro_remoto_fecha_fin) {
        return;
      }
      console.log(
        "this.filtro_remoto_fecha_inicio",
        this.filtro_remoto_fecha_inicio
      );
      console.log("this.filtro_remoto_fecha_fin", this.filtro_remoto_fecha_fin);
      console.log("this.filtro_remoto_estado", this.filtro_remoto_estado);
      this.search = "";
      this.solicitudes = [];
      let me = this;
      let header = { Token: this.$store.state.token };
      let params = {
        fecha_inicio: this.filtro_remoto_fecha_inicio,
        fecha_fin: this.filtro_remoto_fecha_fin,
        estado: this.getEstadoFiltro2Estado(this.filtro_remoto_estado),
      };
      console.log("params", params);
      let configuracion = { headers: header, params: params };
      axios
        .get("picking_y_packing/list", configuracion)
        .then(function (response) {
          console.log("response", response);
          me.solicitudes = response.data;
          if (me.solicitudes) {
            if (me.dialogo_articulos || me.dialogo_adjuntos) {
              console.log("vamos a actualizar me.solicitud", me.solicitud);
              let solicitud_localizada = me.solicitudes.find((element) => {
                console.log("element._id", element._id);
                console.log("me.solicitud._id", me.solicitud._id);
                if (element._id == me.solicitud._id) return true;
              });
              console.log("solicitud_localizada", solicitud_localizada);
              me.solicitud = Object.assign({}, solicitud_localizada);
            }
          }
        })
        .catch(function (error) {
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          } else {
            console.log("listar error", error);
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    verEtiqueta(item) {
      console.log("verEtiqueta", item);
      let me = this;
      let header = { Token: this.$store.state.token };
      let params = { _id: item._id };
      let configuracion = { headers: header, params: params };
      console.log("header configuracion", configuracion);
      axios
        .get("picking_y_packing/queryById", configuracion)
        .then(function (response) {
          console.log("response", response);
          let pdfWindow = window.open("");
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            encodeURI(response.data.envio.etiqueta) +
            "'></iframe>"
          );
        })
        .catch(function (error) {
          console.log("Recibimos error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          } else {
            console.log("listar error", error);
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    queryByRefCli(ref_cliente) {
      console.log("queryByRefCli");
      let me = this;
      let header = { Token: this.$store.state.token };
      let params = { ref_cliente: ref_cliente };
      console.log("params", params);
      let configuracion = { headers: header, params: params };
      console.log("header configuracion", configuracion);
      axios
        .get("picking_y_packing/queryByRefCli", configuracion)
        .then(function (response) {
          console.log("response", response);
          me.solicitudes = new Array(response.data);
        })
        .catch(function (error) {
          console.log("Recibimos error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          } else {
            console.log("listar error", error);
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    insertarSolicitud() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if (!this.esValido()) {
        return;
      }
      axios
        .post("picking_y_packing/add", me.solicitud, configuracion)
        .then(function (response) {
          console.log("response", response);
          me.limpiar();
          me.cerrar();
          me.listar();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    actualizarSolicitud() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if (!me.esValido()) {
        console.log("!this.esValido()", me.solicitud);
        return;
      }
      console.log("this.solicitud", me.solicitud);
      axios
        .put("picking_y_packing/update", me.solicitud, configuracion)
        .then(function (response) {
          console.log("Actualizando solicitud OK");
          console.log("response", response);

          if (!me.actualizarArraySolicitudes(response.data)) {
            me.listar();
          }

          console.log("solicitudes", me.solicitudes);
          me.limpiar();
          me.cerrar();
          console.log("Actualizando solicitud FIN OK");
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    cambiarEstado2Cancelado(item) {
      let me = this;
      let header = { Token: me.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("picking_y_packing/cancelar", { _id: item._id }, configuracion)
        .then(function (response) {
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    abrirArticulos(item) {
      console.log("abrirArticulos");
      this.solicitud = Object.assign({}, item);
      console.log("this.solicitud", this.solicitud);
      this.validaMensaje = [];
      this.dialogo_articulos = true;
    },
    abrirAdjuntos(item) {
      console.log("abrirAdjuntos");
      this.solicitud = Object.assign({}, item);
      console.log("this.solicitud", this.solicitud);
      this.validaMensaje = [];
      this.dialogo_adjuntos = true;
    },
    insertarAdjunto() {
      console.log("insertarAdjunto");
      console.log("fichero_seleccionado", this.fichero_seleccionado);

      if (!this.fichero_seleccionado) {
        this.data = "Fichero no seleccionado";
        return;
      }

      if (this.solicitud.total_adjuntos > 2) {
        me.validaMensaje.push("No se permite añadir más 2 ficheros");
        return;
      }

      let reader = new FileReader();

      reader.readAsDataURL(this.fichero_seleccionado);
      reader.onload = () => {
        this.adjunto = {
          nombre: this.fichero_seleccionado.name,
          fichero: reader.result,
        };
        this.subirAdjunto(this.adjunto);
      };
    },
    subirAdjunto(adjunto) {
      console.log("subirAdjunto");
      console.log("adjunto", adjunto);

      let me = this;
      let header = { Token: me.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "picking_y_packing/insertarAdjunto",
          { _id: me.solicitud._id, adjunto: adjunto },
          configuracion
        )
        .then(function (response) {
          me.validaMensaje = [];
          me.fichero_seleccionado = null;
          me.adjunto = {
            nombre: null,
            fichero: null,
          };
          me.solicitud = response.data;
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          me.fichero_seleccionado = null;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    eliminarAdjunto(item) {
      console.log("eliminarAdjunto item", item);

      let me = this;
      let header = { Token: me.$store.state.token };
      axios
        .delete("picking_y_packing/eliminarAdjunto/", {
          data: { _id: me.solicitud._id, _id_adjunto: item._id },
          headers: header,
        })
        .then(function (response) {
          me.validaMensaje = [];
          me.solicitud = response.data;
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    descargarAdjunto(item) {
      console.log(".................descargarAdjunto", item);
      let me = this;
      let header = { Token: this.$store.state.token };
      let params = { _id: me.solicitud._id, _id_adjunto: item._id };
      let configuracion = { headers: header, params: params };
      console.log("header configuracion", configuracion);
      axios
        .get("picking_y_packing/descargarAdjunto", configuracion)
        .then(function (response) {
          console.log("response", response);
          me.validaMensaje = [];

          let element = document.createElement("a");
          element.setAttribute("href", response.data.base64);
          element.setAttribute("download", response.data.nombre);

          element.style.display = "none";
          document.body.appendChild(element);

          element.click();

          document.body.removeChild(element);
        })
        .catch(function (error) {
          console.log("Recibimos error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          } else {
            console.log("listar error", error);
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    actualizarSolicitudyArticulos() {
      console.log("actualizarSolicitudyArticulos");
      let me = this;
      let header = { Token: me.$store.state.token };
      let configuracion = { headers: header };
      console.log("me.solicitud._id", me.solicitud._id);
      axios
        .put("picking_y_packing/update", me.solicitud, configuracion)
        .then(function (response) {
          if (!me.actualizarArraySolicitudes(response.data)) {
            me.listar();
          }
          console.log("respuesta positiva en actualizarSolicitudyArticulos");
          me.validaMensaje = [];
        })
        .catch(function (error) {
          console.log("Error actualizarSolicitudyArticulos", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
          me.listar();
        });
    },
    insertarArticulo() {
      console.log("insertarArticulo");
      console.log("articulo", this.articulo);
      this.solicitud.articulos.push(Object.assign({}, this.articulo));
      console.log("articulos", this.solicitud.articulos);
      this.articulo = {
        sku_cliente: null,
        cantidad: 1,
        empaquetados: 0,
      };
      this.actualizarSolicitudyArticulos();
    },
    eliminarArticulo(item) {
      console.log("eliminarArticulo");
      console.log("this.solicitud", this.solicitud);
      console.log("this.solicitud.articulos", this.solicitud.articulos);
      console.log("articulo", item);
      let articulos = [];
      for (let art of this.solicitud.articulos) {
        if (art._id != item._id) {
          articulos.push(Object.assign({}, art));
        }
      }
      this.solicitud.articulos = articulos;
      this.actualizarSolicitudyArticulos();
    },
    actualizarBultos(solicitud) {
      let me = this;
      let header = { Token: me.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "picking_y_packing/actualizarBultos",
          { _id: solicitud._id, bultos: solicitud.bultos },
          configuracion
        )
        .then(function (response) {
          console.log("actualizarBultos response.data", response.data);
          me.validaMensaje = [];
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    aumentarBultos() {
      this.solicitud.bultos++;
      this.actualizarBultos(this.solicitud);
    },
    decrementarBultos() {
      this.solicitud.bultos--;
      this.actualizarBultos(this.solicitud);
    },
    exportarArticulosExcel() {
      console.log("exportarArticulosExcel");
      try {
        let articulos = [];
        this.solicitud.articulos.forEach((a) => {
          articulos.push({
            "Sku cliente": a.sku_cliente,
            "Cód. Barras": a.cod_barras,
            Nombre: a.nombre,
            Cantidad: a.cantidad,
            Observaciones: a.observaciones ? a.observaciones : "",
          });
        });
        let worksheet = XLSX.utils.json_to_sheet(articulos);
        let new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "articulos");
        XLSX.writeFile(new_workbook, "articulos.xlsx");
      } catch (error) {
        console.error("export error", error);
      }
    },
    importarExcel2Picking(e) {
      console.log("importarExcel2Picking");
      console.log("e", e);
      console.log("$refs.file_input_pickings", this.$refs.file_input_pickings);

      try {
        let me = this;
        me.validaMensaje = [];
        const fichero_importar_pickings = e.target.files[0];
        console.log("fichero_importar_pickings", fichero_importar_pickings);

        if (!fichero_importar_pickings) {
          return;
        }

        if (fichero_importar_pickings.size > 1000000) {
          me.validaMensaje.push("El fichero no debe sobrepasar 1MB de tamaño");
          return;
        }

        let reader = new FileReader();
        reader.onload = function (e) {
          let solicitudes_a_importar = null;
          try {
            let data = new Uint8Array(e.target.result);
            let workbook = XLSX.read(data, { type: "array" });
            let sheetName = workbook.SheetNames[0];
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log("Conversión a json");
            solicitudes_a_importar = XLSX.utils.sheet_to_json(worksheet);
            console.log("solicitudes_a_importar", solicitudes_a_importar);
          } catch (error) {
            me.$refs.file_input_pickings.value = "";
            me.validaMensaje.push("Fichero incorrecto");
            return;
          }
          console.log("fuera del try");

          if (!solicitudes_a_importar) {
            me.$refs.file_input_pickings.value = "";
            me.validaMensaje.push("Fichero incorrecto");
            return;
          }

          me.auxImportarExcel2Picking(solicitudes_a_importar);

          console.log("Fin de la función");
        };

        reader.readAsArrayBuffer(fichero_importar_pickings);
      } catch (error) {
        console.error("export error", error);
      }
    },
    auxImportarExcel2Picking(solicitudes_a_importar) {
      try {
        let me = this;
        let nuevas_solicitudes = [];

        for (let i = 0; i < solicitudes_a_importar.length; i++) {
          let s = solicitudes_a_importar[i];
          console.log("solicitud", s);

          try {
            s.articulos = JSON.parse(s.articulos);
          } catch (error) {
            console.log("error", error);
            console.log("s.articulos", s.articulos);
            me.validaMensaje.push(
              "Registro " + i + ": Artículos mal definidos"
            );
            me.limpiarSolicitud();
            me.$refs.file_input_pickings.value = "";
            return;
          }

          me.solicitud = me.auxComponerSolicitud(s);
          console.log("me.solicitud.articulos", me.solicitud.articulos);

          if (!me.esValido()) {
            me.limpiarSolicitud();
            me.$refs.file_input_pickings.value = "";
            return;
          }

          nuevas_solicitudes.push(me.solicitud);
        }
        me.limpiarSolicitud();
        me.$refs.file_input_pickings.value = "";
        // Si todas las solicitudes aparentemente están correctas
        console.log("nuevas_solicitudes", nuevas_solicitudes);

        if (nuevas_solicitudes.length == 0) {
          me.validaMensaje.push(
            "El fichero no contiene solicitudes de Picking y Packing"
          );
          return;
        }

        console.log("Hay nuevas_solicitudes");
        console.log("Antes de enviar las solicitudes");
        me.auxInsertarSolicitudesValidadas(nuevas_solicitudes);
      } catch (error) {
        console.error("export error", error);
      }
    },
    auxComponerSolicitud(s) {
      console.log("auxComponerSolicitud");
      return {
        ref_cliente: s.ref_cliente,
        bultos: s.bultos,
        envio: {
          servicio: s.servicio,
          horario: s.horario,
          peso: s.peso,
          destinatario: {
            nombre: s.nombre,
            direccion: s.direccion,
            poblacion: s.poblacion,
            pais: "34",
            cp: s.cp,
            telefono: s.telefono,
            movil: s.movil,
            email: s.email,
            att: s.att,
          },
          reembolso: s.reembolso,
        },
        observaciones_preparacion: s.observaciones_preparacion,
        articulos: s.articulos,
      };
    },
    auxInsertarSolicitudesValidadas(nuevas_solicitudes) {
      console.log("auxInsertarSolicitudesValidadas");
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post("picking_y_packing/addAll", nuevas_solicitudes, configuracion)
        .then(function (response) {
          console.log("response", response);
          me.limpiar();
          me.validaMensaje.push("¡Importación completada!");
          me.listar();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data) {
            if (error.response.data.message) {
              msj_error = error.response.data.message;
            }
            if (
              error.response.data.nuevos_pickings &&
              error.response.data.nuevos_pickings.length > 0
            ) {
              me.validaMensaje.push(error.response.data.nuevos_pickings);
            }
          }
          me.validaMensaje.push(msj_error);
          me.listar();
        });
    },
    exportarPicking2Excel() {
      console.log("exportarPicking2Excel");
      try {
        let picking = [];
        this.solicitudes.forEach((s) => {
          s.resumen_articulos = "";
          let i = 1;
          s.articulos.forEach((a) => {
            s.resumen_articulos += `Art. ${i}: ${a.nombre} - Cantidad art. ${i}: ${a.cantidad}, `;
            i++;
          });
          if (s.resumen_articulos.length > 2) {
            s.resumen_articulos = s.resumen_articulos.substring(
              0,
              s.resumen_articulos.length - 2
            );
          }
          picking.push({
            Fecha: this.formatearFechayHora(s.creacion),
            "Cód. Cliente": s.cliente.codigo,
            "Ref. Cliente": s.ref_cliente,
            "Cód. Exp": s.envio.cod_exp,
            "Cód. Barras": s.cod_barras,
            Destinatario: s.envio.destinatario.nombre,
            Dirección: s.envio.destinatario.direccion,
            "C.P.": s.envio.destinatario.cp,
            Población: s.envio.destinatario.poblacion,
            Estado: this.getNombreEstado(s.estado),
            Bultos: s.bultos,
            "Nº Artículos": s.articulos.length,
            "Total Artículos": s.total_articulos,
            Artículos: s.resumen_articulos,
            "Obs preparacion": s.observaciones_preparacion,
            "Obs entrega": s.envio.destinatario.observaciones,
            Adjuntos: s.adjuntos.length,
            Embalaje: s.embalaje,
          });
        });
        let worksheet = XLSX.utils.json_to_sheet(picking);
        let new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "picking");
        XLSX.writeFile(new_workbook, "picking.xlsx");
      } catch (error) {
        console.error("export error", error);
      }
    },
    cerrar() {
      this.dialogo_picking = false;
      this.limpiar();
    },
    cerrarDialogArticulos() {
      this.dialogo_articulos = false;
      this.limpiar();
      this.listar();
    },
    cerrarDialogAdjuntos() {
      this.dialogo_adjuntos = false;
      this.limpiar();
      this.listar();
    },
    actualizarArraySolicitudes(nueva) {
      console.log("actualizarArraySolicitudes nueva", nueva);
      if (!this.solicitudes) return false;

      let indice = -1;
      let encontrado = this.solicitudes.some(function (e, i, array) {
        if (e._id == nueva._id) {
          indice = i;
          return true;
        }
      });

      if (!encontrado) return false;
      console.log("LOCALIZADA SOLICITUD ACTUALIZADA");
      this.solicitudes.splice(indice, 1, nueva);
      if (this.dialogo_articulos) {
        this.solicitud = Object.assign({}, nueva);
      }

      return true;
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0px;
}
</style>